import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "nav flex-column menu-list list-unstyled" }
const _hoisted_2 = { class: "menu-list__item" }
const _hoisted_3 = { class: "submenu-list btn-toggle-nav list-unstyled pb-1 small" }
const _hoisted_4 = { "data-bs-dismiss": "offcanvas" }
const _hoisted_5 = { class: "nav flex-column menu-list list-unstyled mt-4" }
const _hoisted_6 = { class: "d-flex fle-row align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("a", {
          class: "w-100 d-flex flex-row justify-content-between",
          "data-bs-toggle": "collapse",
          href: "#collapse",
          role: "button",
          "aria-expanded": "false",
          style: _normalizeStyle({ fontWeight: _ctx.isActive ? 800 : 500 }),
          onClick: _cache[0] || (_cache[0] = () => _ctx.handleClick())
        }, [
          _createElementVNode("div", null, [
            _createVNode(_component_Icon, {
              class: "me-3",
              name: "fingerprint"
            }),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Instalação de SSL", -1))
          ]),
          _createVNode(_component_Icon, { name: "angle-down" })
        ], 4)
      ]),
      _createElementVNode("div", {
        id: "collapse",
        ref: "menuRef",
        class: _normalizeClass(['collapse', { show: _ctx.isActive }])
      }, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuSSLInstallation, (url, name) => {
            return (_openBlock(), _createElementBlock("li", {
              key: url + name,
              class: "submenu-list__item"
            }, [
              _createVNode(_component_Icon, {
                class: "me-3",
                name: "arrow-right"
              }),
              _createVNode(_component_router_link, {
                to: `${url}`,
                onClick: _cache[1] || (_cache[1] = () => _ctx.handleClick(true))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, {
        to: "digital-certificate-plugin",
        class: "w-100 d-flex flex-row justify-content-between",
        style: _normalizeStyle({
        fontWeight: _ctx.isCurrentRoutePluginHelpPage && !_ctx.isActive ? 800 : 500,
      })
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Icon, {
              class: "me-3",
              name: "display-arrow-down"
            }),
            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Plugin de instalação de Certificados Digitais A1", -1))
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ])
  ], 64))
}